export default {
    title: 'Ready to begin?',
    subtitle: 'Just follow the steps to launch your 360 Feedback!',
    selectReviewee: {
        stepTitle: 'Reviewees',
    },
    assignReviewer: {
        stepTitle: 'Respondents',
    },
    templateSelection: {
        stepTitle: 'Questionnaire Templates',
    },
    questionnaireCreation: {
        stepTitle: 'Build your Review',
    },
    scheduleCreation: {
        stepTitle: 'Launch the 360 Feedback',
    },
};
